import { ActiveMenu } from "../../StateManagment/ActiveMenuItem";
import { ImpactAI } from "../../StateManagment/ImpactAI";
import { Auth } from '../../StateManagment/Auth';
import { useContext, useEffect } from "react";
import { CommunicationSystemMessage } from "../../hooks/impactAI/Prompts"
import { useHistory } from 'react-router-dom';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import { client } from "../../hooks/Client"

const Communication = () => {
  // Context
  const [auth] = useContext(Auth)
  const { active, setActive, activeSubItem, setActiveSubItem } = useContext(ActiveMenu);
  const {
      type: [type, setType],
      systemMessage: [systemMessage, setSystemMessage],
      startMessage: [startMessage, setStartMessage],
      exampleMessages: [exampleMessages, setExampleMessages],
      chatOpen: [chatOpen, setChatOpen]
  } = useContext(ImpactAI);

  // Hooks
  const history = useHistory()

  //ImpactAI
  const pageSystemMessage = CommunicationSystemMessage()
  const pageStartMessage = `Welkom bij Communiceren, ${auth?.ForName}. Hier kun je gerealiseerde en onderbouwde impact communiceren via live-rapportages.
  Kan ik je ergens mee helpen?`
  const pageExampleMessages = ['Wat zijn live-rapportages?']
  const pageType = 'communication'

  useEffect(() => {
     setType(pageType)
     setSystemMessage(pageSystemMessage)
     setStartMessage(pageStartMessage)
     setExampleMessages(pageExampleMessages)
 }, [auth])

 const segmentSteps = [
  {
    name: 'Live-rapportages',
    url: 'livereports2',
  }
]

  return (
    <div className="main">
      <div className="main-container">
          <div className="page-header">
              <AssessmentOutlinedIcon/>
              <h1>Communiceren</h1>
          </div>
          <div className='section-explainer-text-container'>
            <div>
              <p>Welkom bij Communiceren, {auth?.ForName}. Hier ga je je gerealiseerde en onderbouwde impact communiceren via live-rapportages.</p>
            </div>
            <div id='segment-overview-steps-container'>
              {segmentSteps.map((step, index) => (
                <div 
                key={index} 
                className="segment-overview-step-container"
                onClick={() => {
                  history.push(`/${client}/${step.url}`);
                  setActive('communication');
                  setActiveSubItem(step.url)
                }}
                >
                  <div className="segment-overview-step-inner-container">
                    <div className="segment-overview-checked-name-container">
                      <div>
                        <p><b>{step.name}</b></p>
                      </div>
                    </div>
                    <p id='segment-overview-step-button' onClick={() => history.push(`/${client}/${step.url}`)}>Bekijk/aanpassen</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
    </div>
  )
}

export default Communication